import React from 'react';
import { Link } from 'react-router-dom';
import styles from './styles.module.scss';

const SelEncyclopedia = () => (
  <div className={`container ${styles.encyclopediaContainer}`}>
    <div className="row">
      <div className="col-12 col-lg-6 sizing">
        <h1>What are SEL Power Skills?</h1>
        <h3>
          Social-Emotional Learning (SEL) builds the key Power Skills needed for
          success.
        </h3>
        <p>
          <strong>Social-Emotional Learning (SEL)</strong> is the process.{' '}
          <strong>Power Skills</strong> are the result. While some once labeled
          these as ‘soft skills,’ we agree with leading experts who call them
          ‘Power Skills.' They give power to knowledge and the people who use
          them. At Unyted, we embrace the existing leading science in the field,
          work with top research methodologists to contribute our own research,
          and focus the SEL process on the development of Power Skills (and
          related knowledge, attitudes and mindsets) generally falling under a
          set of core 5 categories (see list of buttons).
        </p>
        <p>
          Science already shows these categories and the corresponding skills
          are mutual: they work together. Learners do not merely acquire
          information (cognitive) in isolation. Instead, learners use the{' '}
          <strong> Power Skills </strong> gained through SEL to *use* the
          information they attain. In concrete terms, if you know a lot about a
          subject, <strong>Power Skills</strong> are necessary to apply that
          knowledge in the real world. We'll help you develop them, together.
        </p>
      </div>
      <div className="col-12 col-lg-5 offset-lg-1">
        <div className={styles.competencySelector}>
          <Link to="/sel-encyclopedia/competencies/self-awareness">
            Self Awareness
            <div className={styles.description}>Managing Yourself</div>
          </Link>
          <Link to="/sel-encyclopedia/competencies/self-management">
            Self Management
            <div className={styles.description}>Knowing Yourself</div>
          </Link>
          <Link to="/sel-encyclopedia/competencies/social-awareness">
            Social Awareness
            <div className={styles.description}>Being Aware of Others</div>
          </Link>
          <Link to="/sel-encyclopedia/competencies/relationship-skills">
            Relationship Skills
            <div className={styles.description}>Functioning with Others</div>
          </Link>
          <Link to="/sel-encyclopedia/competencies/responsible-decision-making">
            Responsible Decision Making
            <div className={styles.description}>Making Effective Decisions</div>
          </Link>
        </div>
      </div>
    </div>
  </div>
);

export default SelEncyclopedia;
